// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"O8TUn5h0"};